/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Container, Row, Col, Spinner, Alert, Modal } from "react-bootstrap";
import Header from "../Header";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircle,
  faCheckCircle,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import "./NewInterviewKit.scss";
import useAssignedInterviewKit from "./useAssignedInterviewKit";

export default (props) => {
  const {
    loading,
    loadingError,
    interviewKit,
    readMore,
    acceptLoading,
    isDeclineAssessmentModal,
    userToken,
    onReadMoreClick,
    onPracticeClick,
    onStartClick,
    onSubmitClick,
    onAcceptAssessmentKitClick,
    handleIsDeclineAssessmentModal,
    onAcceptAssessmentKitDetailsClick,
  } = useAssignedInterviewKit(props);

  return (
    <div className="pb-5 create-interview-overview">
      <Header />
      <div>
        <Container>
          <Row>
            {loading ? (
              <Spinner animation="border" variant="primary" />
            ) : (
              <Col className="col-md-10 offset-md-1">
                {loadingError && loadingError.length > 0 ? (
                  <div className="col-6">
                    <p className="font-weight-bold">
                      Oops something went wrong.
                    </p>
                    <p className="font-weight-bold">{loadingError}</p>
                  </div>
                ) : (
                  <div className="bg-grey p-4">
                    <div className="d-flex align-items-center mb-4">
                      <div className="border-radius-10 mr-3 company-logo mt-4 pt-1">
                        <img src={"/assets/images/logo.png"} alt="user" />
                      </div>

                      <h2 className="pl-3">
                        One-way video interview - {interviewKit?.title}
                      </h2>
                    </div>
                    <div className="inner-content">
                      <div className="row">
                        <div className="col-6">
                          <p>
                            Mentor:{" "}
                            <span className="font-weight-bold">
                              {interviewKit?.created_by_details &&
                                interviewKit.created_by_details?.full_name}
                            </span>
                          </p>
                        </div>
                        <div className="col-6 text-right">
                          <div className="alert alert-primary fs-smallest border-0 py-1 d-inline-block">
                            SUBMIT BY: {interviewKit?.due_date}
                          </div>
                        </div>
                      </div>
                      <div className="text-grey-4">
                        {interviewKit?.welcome_note !== null ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: interviewKit?.welcome_note,
                            }}
                          ></div>
                        ) : null}

                        <div
                          dangerouslySetInnerHTML={{
                            __html: interviewKit?.epilogue_outro_note,
                          }}
                          className="mt-4"
                        ></div>
                      </div>

                      <div className="border-bottom py-4 text-grey-4">
                        <p className="text-dark-2 font-weight-semi">
                          Topics to be preapared:
                        </p>
                        <ul className="mb-4">
                          {interviewKit?.topics && Array.isArray(interviewKit.topics) &&
                            interviewKit.topics.map((item, index) => (
                              <li
                                className="d-flex align-items-center"
                                key={index}
                              >
                                <FontAwesomeIcon
                                  icon={faCircle}
                                  className="fs-6 mr-3"
                                />
                                {item?.name}
                              </li>
                            ))}
                        </ul>
                        <p className="text-dark-2 font-weight-semi">
                          Total questions: {interviewKit?.total_question} •
                          Estimated time: {interviewKit?.total_time} mins
                        </p>
                      </div>
                      <div className="py-4 text-grey-4">
                        <ul className="mb-4">
                          <li className="d-flex align-items-center">
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className="text-primary mr-3"
                            />
                            After starting, you’ll have time to read the
                            question and record when you’re comfortable
                          </li>
                          {/* <li className="d-flex align-items-center">
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className="text-primary mr-3"
                            />
                            You’re able to take breaks in between questions
                          </li> */}
                          <li className="d-flex align-items-center">
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              className="text-primary mr-3"
                            />
                            All recordings must be submitted by the specific
                            date
                          </li>
                        </ul>
                        {interviewKit?.is_declined ? (
                          <div className="actions">
                            <Alert variant={"primary"}>
                              <FontAwesomeIcon
                                icon={faInfoCircle}
                                className="mr-2"
                              />
                              You have declined this Assessment Interview kit.
                            </Alert>
                          </div>
                        ) : (
                          <>
                            {interviewKit?.is_accepted ? (
                              <>
                                {interviewKit?.is_submit ? (
                                  <div className="actions d-flex align-items-center">
                                    <p>Already completed?</p>
                                    <button
                                      className="btn btn-primary border ml-4"
                                      onClick={() => onSubmitClick()}
                                    >
                                      Submit Interview
                                    </button>
                                  </div>
                                ) : (
                                  <div className="actions d-flex align-items-center">
                                    {interviewKit?.answered_questions && (
                                      <p>
                                        {interviewKit?.answered_questions}{" "}
                                        Questions left.
                                      </p>
                                    )}
                                    <button
                                      className="btn btn-light border"
                                      onClick={() => onPracticeClick()}
                                    >
                                      Let’s practice first
                                    </button>
                                    <button
                                      className="btn btn-primary ml-4"
                                      onClick={() => onStartClick()}
                                    >
                                      I’m ready, let’s start
                                    </button>
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="actions d-flex align-items-center">
                                <button
                                  className="btn btn-primary"
                                  onClick={() =>
                                    onAcceptAssessmentKitDetailsClick(true)
                                  }
                                >
                                  {userToken ? "Accept" : "Sign in to Accept"}
                                </button>
                                {/* <button
                                  className="btn btn-light border ml-4"
                                  onClick={() =>
                                    handleIsDeclineAssessmentModal()
                                  }
                                >
                                  Decline
                                </button> */}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </Col>
            )}
          </Row>
        </Container>

        <Modal
          show={isDeclineAssessmentModal}
          centered
          size="md"
          onHide={handleIsDeclineAssessmentModal}
          className="common-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h3>Reject Assessment</h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-3 bg-white d-flex align-items-center justify-content-center flex-column">
            <h4>Are you sure you want to reject this Assessment?</h4>

            <div className="action mt-4">
              <button
                className="btn btn-primary px-5"
                onClick={() => onAcceptAssessmentKitClick(false)}
              >
                Yes
              </button>
              <button
                className="btn btn-dark ml-4 px-5"
                onClick={() => handleIsDeclineAssessmentModal()}
              >
                Cancel
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};
